import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import { TaskCategory } from 'aos-services/src/services/tasks/types/TaskCategory'
import { DialogView } from 'aos-ui/src/components/modal/MapAwareModal'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'
import { TaskLocationField } from '../TaskLocationField'

interface TaskLocationFormFieldProps {
    isTaskTemplate: boolean
    setViewMode(n: DialogView): void
}

export const TaskLocationFormField = ({
    isTaskTemplate,
    setViewMode,
}: TaskLocationFormFieldProps) => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()
    const task = useWatch({ control }) as TaskFormPayload

    return (
        <Controller
            control={control}
            name='location'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.location.label', { ns: 'tasks' })}
                    required={task.category === TaskCategory.Animals && !isTaskTemplate}
                    error={
                        fieldState.error
                            ? translate('form.location.error', { ns: 'tasks' })
                            : undefined
                    }
                >
                    <TaskLocationField
                        location={field.value}
                        onOpenOnMap={() => setViewMode(DialogView.Map)}
                        onClear={() => field.onChange(undefined)}
                    />
                </TaskFormField>
            )}
        />
    )
}
